<template>
	<div class="login-wrap">
		<van-icon class="back" @click="back" name="arrow-left" size="24"></van-icon>
		<div class="login-title">账号登录</div>
		<div class="input-wrap">
			<van-field class="input" v-model="tel" type="text" placeholder="请输入账号">
			</van-field>
		</div>
		<div class="input-wrap">
			<van-field class="input" clearable v-model="password" :type="showPassword? 'text' : 'password'" :right-icon="showPassword ? 'closed-eye' : 'eye-o'" @click-right-icon="showPassword = !showPassword" placeholder="请输入密码">
				<template slot="icon">
					<van-icon name="arrow"></van-icon>
				</template>
			</van-field>
		</div>
		<div class="login-button" >
			<van-button type="info" :disabled="!validated" block @click="doLogin">登录</van-button>
		</div>
		<div class="login-methods">
			<span @click="toMsgLogin">短信登录</span>
		</div>
		<div class="bottom">
			<div class="provider">
				<span>微信登录</span>
				<img src="../assets/images/wx.png" alt="">
			</div>
			<div class="protocal">
				阅读<span class="detail">《用户协议与隐私政策》</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AccoutLogin',
		data() {
			return {
				tel: '',
				password: '',
				showPassword: false,
				validated: true
			}
		},
		watch: {
			// tel(val) {
			// 	let reg = /^1[3-9]\d{9}$/
			// 	if (reg.test(val)) {
			// 		this.validated = true
			// 	} else {
			// 		this.validated = false
			// 	}
			// }
		},
		methods: {
			back() {
				this.$router.goBack()
			},
			doLogin() {
				this.$api.post('Login', {
					account: this.tel,
					password: this.password
				}).then(res => {
					if (res.resultCode == 0) {
						if (typeof plus != "undefined") {
							uni.reLaunch({
								url: `../main/main?token=${res.access_token}&operator=${res.user_id}`
							})
						} else {
							localStorage.setItem('token', res.access_token)
							localStorage.setItem('operator', res.user_id)
							this.$router.push('home')
						}
					} else {
						Toast(res.resultMessage)
					}
				})
			},
			toMsgLogin() {
				this.$router.goBack()
			}
		}
	}
</script>

<style lang="less" scoped>
	.login-wrap {
		font-size: 16px;
		.back {
			margin: 20px;
		}
	}
	.input-wrap {
		margin: 24px;
		border-bottom: 1px solid #f1f1f1;
		padding: 6px 0;
		.van-field__label{
			width: 50px;
			color: #666666;
		}
		.input {
			padding: 6px 0;
		}
	}
	.login-title {
		font-size: 24px;
		margin: 20px;
		margin-top: 60px;
	}
	.dict {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.login-button {
		margin: 0 24px;
		.van-button--disabled {
			opacity: 1;
			border: 1px solid #acacac;
			background-color: #acacac;
		}
	}
	
	.login-methods {
		padding: 10px 24px;
		font-size: 12px;
		color: #6a6a6a;
	}
	.bottom {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 120px;
		.provider {
			display: flex;
			flex-direction: column;
			align-items: center;
			color: #6a6a6a;
			img {
				width: 50px;
				height: 50px;
				margin-top: 4px;
			}
		}
		.protocal {
			margin-top: 10px;
			display: flex;
			justify-content: center;
			font-size: 12px;
			color: #6a6a6a;
			.detail {
				margin-left: 2px;
				color: #1989fa;
				font-size: 12px;
			}
		}
	}
</style>
